module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-cover-6-0657d3c594bce080ee4547fccd3984b8.jpg";